export default __webpack_public_path__ + "static/media/pokeball.3d6051b7.gif";